import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

import ActCRUDTable from "../../components/CRUD/Tables/ActCRUDTable";
import {actCRUD, actFormCRUD} from "../../http";
import DashboardLayout from "../../layouts/Dashboard";
import useReload from "../../hooks/useReload";
import {confirmDialog} from "../../components/Dialog/DialogDelete";
import {canDeleteDocumentRow, canShowDocumentDeleteAction} from "../../functions/ksekDeletePermissions";
import { actFormTypeIds } from "../../models/actFormTypeIds";

const ActTable = () => {
  const { pathname } = useLocation()
  const [actForm, setActForm] = useState(null);
  const [path, setPath] = useState(null);
  let isDSEK = `${pathname[1].toUpperCase()}${pathname.substring(2)}`.includes('DSEK')
  useEffect(() => {
    let path = `${pathname[1].toUpperCase()}${pathname.substring(2)}`.replace('DSEK', '');
    setPath(path);
    actFormCRUD.search({
      "filter": {
        "number": {
          "operand1": path,
          "operator": 1
        },
      }
    }).then((data) => {
      if (data.result.length > 0)
        setActForm(data.result[0]);
      else
        setActForm({id: null});
    })
  }, [pathname])

  const { reload, reloadValue } = useReload();

  const handleDelete = (_) => {
    return confirmDialog('Удаление акта, ID:' + _, 'Вы действительно хотите удалить этот акт?', async () => {
      await actCRUD.delete(_);
      await reload();
    })
  }

  const extraFilter = {    
    "orderType": {
      "operand1": isDSEK ? 2 : 1,
      "operator": 1
    },
    "form": {
      "typeId": {
        "operand1": actFormTypeIds.act,
        "operator": "equals"
      }
    }
  }

  if (actForm?.id) {
    extraFilter.formId = {
      "operand1": actForm?.id,
      "operator": 'equals'
    };
  }

  const readonly = path == 'Act' || path == 'ActDSEK';

  const canDelete = canShowDocumentDeleteAction();

  return (
    <DashboardLayout style={{ display: "flex", flexDirection: "column" }}>
      {actForm
        ? <ActCRUDTable
            reloadValue={reloadValue}
            onClickDeleteButton={canDelete ? handleDelete : null}
            deleteVisibleFunc={(record) => canDeleteDocumentRow(record)}
            extraFilter={extraFilter}
            readonly={readonly}
          />
        : <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </div>}
    </DashboardLayout>
  );
};

export default ActTable;
